import React, { useState, useEffect,useRef, useLayoutEffect } from 'react';
import { Container, Row, Col, Form, Button, Spinner, Alert, Card } from 'react-bootstrap';
import { newUserCreation } from "./userCreateAction";
import { getAllUserRole } from "../userRole/allUserRoleActions";
import { FaArrowLeft } from 'react-icons/fa';
import { useDispatch, useSelector } from "react-redux";
import * as bootstrap from 'bootstrap';
import Swal from "sweetalert2";
import { Link,useNavigate } from 'react-router-dom';

const initialState = {
  username: "",
  contactno: "",
  email: "",
  role_id: "",
  password: "",
  confirmPassword: "",
  address: "",
  address2: "",
  avatar: null,
  user_status: "",

}

/* username: "Kavya",
contactno: "1234567890",
email: "kavya@royalarabian.com",
role_id: 1,
password: "asdf1233D@",
confirmPassword: "asdf1233D@",
address: "Mangalore",
address2: "Mangalore",
user_status: 1, */

const passVerificationError = {
  isLenthy: false,
  hasUpper: false,
  hasLower: false,
  hasNumber: false,
  hasSpeclChr: false,
  confirmPass: true
};

const CreateUser = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [newUser, setNewUser] = useState(initialState);
  const [passwordError, setPasswordError] = useState(passVerificationError);
  const [alertStatus, setAlertStatus] = useState('');
  const [avatar, setAvatar]= useState(null);
  const [contactNoError, setContactNoError] = useState(false);
  const [emailError, setEmailError] = useState(false);
  const [nameError, setNameError] = useState(false);

  const { isLoading, status, message } = useSelector((state) => state.userCreate);
  const { userRoles }= useSelector((state) => state.allUserRoles);

  const firstUpdate = useRef(true);
  useLayoutEffect(() => {
    if (firstUpdate.current) {
      firstUpdate.current = false;
      loadUserRole();
      return;
    }

    //console.log("componentDidUpdateFunction");
  });
useEffect(() => {
 
  loadUserRole();
   }, [newUser]);


   function loadUserRole(){
 
    dispatch(getAllUserRole());
  
   
 }

const handleAvatarChange = (event) => {
  const name = event.target.name;
  const value = event.target.files[0] ;
  setAvatar(event.target.files[0]);
  setNewUser({ ...newUser, [name]: value });
};

  const handleOnChange = (e) => {
    const name = e.target.name;
    const value = e.target.value;
     console.log('name '+name); 
    console.log('value '+value); 
    setNewUser({ ...newUser, [name]: value });

    if (name === "contactno") {
      if (!/^\d+$/.test(value) || (value.length < 10 || value.length >= 15)) {
        setContactNoError('Enter a valid mobile number');
      } else {
        setContactNoError('');
      }
    }
    if (name === "email") {
      if (value.includes("@")) {
        setEmailError(false);
      } else {
        setEmailError(true);
      }
    }

    if (name === "username") {
      if (!/^[a-zA-Z]+$/.test(value)) {
        setNameError('Enter valid supplier name');
      } else {
        setNameError('');
      }
    }

    

    if (name === "password") {
      const isLenthy = value.length > 8;
      const hasUpper = /[A-Z]/.test(value);
      const hasLower = /[a-z]/.test(value);
      const hasNumber = /[0-9]/.test(value);
      const hasSpeclChr = /[@,#,$,%,&]/.test(value);
      setPasswordError({
        ...passwordError,
        isLenthy,
        hasUpper,
        hasLower,
        hasNumber,
        hasSpeclChr,
        confirmPass: newUser.confirmPassword === value,
      });
    }

    if (name === "confirmPassword") {
       //console.log( 'Testdata',newUser.password+ '==='+ value);
       //console.log(newUser.password === value);
      setPasswordError({
        ...passwordError,
        confirmPass: newUser.password === value,
      });
    }
  };
  const isFormFilled = () => {
    const {
      username,
      contactno,
      email,
      role_id,
      password,
      confirmPassword,
      address,
      address_two,
      user_status,
    } = newUser;
  
    return (
      username !== "" &&
      contactno !== "" &&
      email !== "" &&
      role_id !== "" &&
      password !== "" &&
      confirmPassword !== "" &&
      address !== "" &&
      address_two !== "" &&
      user_status !== "" &&
      !contactNoError &&
      !emailError
    );
  };
  
  const isDisabled = !isFormFilled || passwordError || nameError ;

  const handleOnSubmit = (e) => {
    e.preventDefault();

    if (contactNoError || emailError) {
      return;
    }
    console.log(newUser);
    const { username, contactno, email, role_id, password, address, address_two, user_status,avatar
    } = newUser;
    let formData = new FormData();

    formData.append("username",username);
    formData.append("contactno",contactno);
    formData.append("email",email);
    formData.append("role_id",role_id);
    formData.append("password",password);
    formData.append("address",address);
    formData.append("address_two",address_two);
    formData.append("user_status",user_status);
    formData.append("avatar",avatar);

    Swal.fire('User Created Successfully!', '', 'success')
   
    console.log(formData);
    dispatch(newUserCreation(formData));
    navigate("/allUsers")
    e.target.reset();
  //  window.location.reload(true);                                      
  };
  
  return (
    <>
     
     <div className="my-4  container-xl">
                <div className="card" style={{marginTop:'-80px'}}>
                    <div className="card-header">
                        <h3 className="d-flex text-dark text-left mt-2 mb-2"  style={{fontFamily:'Times New Roman', fontWeight:'600' }}>Create New User</h3>
                    </div>
                    <div className="card-body">
                        <Row>
                            <Link to="/allUsers"><span className="badge bg-success" style={{backgroundColor:'rgb(156 186 237)',color:'white'}}><FaArrowLeft />&nbsp;Go Back</span></Link> 
   
                        </Row>
                        <br />
            <Form className=" mx-4 my-2" component="form"   noValidate autoComplete="off" onSubmit={handleOnSubmit}>

              <Row className="mb-3">
                <Form.Group as={Col} controlId="formGridUsername">
                  <Form.Label>User Name <span style={{color:"red"}}>*</span></Form.Label>
                  <Form.Control type="text" required name="username" autoComplete='off' placeholder="Enter Username" onChange={handleOnChange} maxLength={30}/>
                  {nameError && <p className='text-danger'>Enter valid user name</p>}
                </Form.Group>

                {/* <Form.Group as={Col} controlId="formGridContactNo">
                  <Form.Label>Contact No <span style={{color:"red"}}>*</span></Form.Label>
                  <Form.Control type="text" required name="contactno" placeholder="Contact No" onChange={handleOnChange}/>
                </Form.Group> */}
                <Form.Group as={Col} controlId="formGridContactNo">
                  <Form.Label>Contact No <span style={{ color: "red" }}>*</span></Form.Label>
                  <Form.Control
                    type="text"
                    required
                    name="contactno"
                    placeholder="Contact No"
                    onChange={handleOnChange}
                    isInvalid={contactNoError} // Add isInvalid prop to highlight the field in case of an error
                  />
                  {contactNoError && (
                    <Form.Control.Feedback type="invalid">
                      Please enter a valid contact number containing only digits
                    </Form.Control.Feedback>
                  )}
                </Form.Group>

              </Row>
              <Row className="mb-3">
                {/* <Form.Group as={Col} controlId="formGridEmail">
                  <Form.Label>Email Address  <span style={{color:"red"}}>*</span></Form.Label>
                  <Form.Control type="email" required name="email" placeholder="Enter email" onChange={handleOnChange}/>
                </Form.Group> */}
                <Form.Group as={Col} controlId="formGridEmail">
  <Form.Label>Email Address  <span style={{color:"red"}}>*</span></Form.Label>
  <Form.Control type="email" required name="email" placeholder="Enter email" onChange={handleOnChange} isInvalid={emailError} />
  {emailError && (
    <Form.Control.Feedback type="invalid">
      Email should contain the "@" symbol.
    </Form.Control.Feedback>
  )}
</Form.Group>
                <Form.Group as={Col} controlId="formGridUserRole">
                  <Form.Label>User Role  <span style={{color:"red"}}>*</span></Form.Label>
                  
                  {/* <Form.Select  name="role_id" onChange={(e) => handleOnChange(e)}>
                  <option value="">Choose..</option>
                    {userRoles.map((urole,index) =>
                  
                    <option key={urole.id} value={urole.id}  >{urole.user_role}</option>
                    )}
                  </Form.Select> */}
                  <Form.Select name="role_id" onChange={(e) => handleOnChange(e)}>
  <option value="">Choose..</option>
  {userRoles.map((urole, index) => {
    if (urole.status === 1) {
      return (
        <option key={urole.id} value={urole.id}>
          {urole.user_role}
        </option>
      );
    } else {
      return null; // Don't render the option
    }
  })}
</Form.Select>

                </Form.Group>
              </Row>
              <Row className="mb-3">
                <Form.Group as={Col} controlId="formGridPassword">
                  <Form.Label>Password  <span style={{color:"red"}}>*</span></Form.Label>
                  <Form.Control type="password" required name="password" autoComplete='off' placeholder="Password" onChange={handleOnChange} />
                </Form.Group>
                <Form.Group as={Col} controlId="formGridConfirmPassword">
                  <Form.Label>Confirm Password  <span style={{color:"red"}}>*</span></Form.Label>
                  <Form.Control type="password" required name="confirmPassword" placeholder="Confirm Password" onChange={handleOnChange} />
                  <Form.Text>
                    
                    {!passwordError.confirmPass && (
                      <div className="text-danger mb-3">Password doesn't match</div>
                    )}
                  </Form.Text>
                </Form.Group>

              </Row>
              <Row className="mb-3">
              <Form.Group as={Col} controlId="formGridAddress1">
                <Form.Label>Address  <span style={{color:"red"}}>*</span></Form.Label>
                <Form.Control placeholder="1234 Main St" required name="address" onChange={handleOnChange} maxLength={50}/>
              </Form.Group>

              <Form.Group as={Col} controlId="formGridAddress2">
                <Form.Label>Address 2  <span style={{color:"red"}}>*</span></Form.Label>
                <Form.Control placeholder="Apartment, studio, or floor" onChange={handleOnChange} maxLength={50} required name="address_two"/>
              </Form.Group>
              </Row>
              <Row className="mb-3">
                <Form.Group as={Col} controlId="formGridStatus">
                  <Form.Label>Status  <span style={{color:"red"}}>*</span></Form.Label>
                  <Form.Select required name="user_status" onChange={handleOnChange}>
                    
                    <option value="">Choose..</option>
                    <option value="1">Enable</option>
                    <option value="0">Disable</option>
                  </Form.Select>
                </Form.Group>
                </Row>
                <Row className="mb-3">
                <Form.Group controlId="formFile" className="mb-3">
                    <Form.Label>Upload Profile Image</Form.Label>
                    <Form.Control type="file" name="avatar" accept="image/*"  onChange={handleAvatarChange} custom/>
              </Form.Group>
                <ul className="mab-4 mt-3">
                  <li className={
                    passwordError.isLenthy ? "text-success" : "text-danger"
                  }> Min 8 Characters</li>
                  <li
                    className={
                      passwordError.hasUpper ? "text-success" : "text-danger"

                    }>
                    At least one upper case
                  </li>
                  <li
                    className={
                      passwordError.hasLower ? "text-success" : "text-danger"
                    }>
                    At least on lower case
                  </li>
                  <li
                    className={
                      passwordError.hasNumber ? "text-success" : "text-danger"
                    }
                  >
                    At least one number
                  </li>
                  <li
                    className={
                      passwordError.hasSpeclChr ? "text-success" : "text-danger"
                    }
                  >
                    At least one of the special characters i.e @ # $ % & {" "}
                  </li>
                </ul>
              </Row>

              <Button variant="primary" type="submit" disabled={!isFormFilled() || Object.values(passwordError).includes(false) || nameError } >
                Submit
              </Button>
              {isLoading && (<Spinner variant='info' animation='border' />)}

            </Form>
          </div>
          </div>
          </div>
    </>
  );
}

export default CreateUser;

